import React from 'react';
import { useHistory } from 'react-router-dom';
import '../css/bigpicturebutton.css';

function WeekReflectionButton({date, entries}) {
    const history = useHistory();
    const dateString = date.toDateString().replace(/\s+/g, '-').toLowerCase();

    const onClick = () => {
        const fullUrl = `week-reflection?date=${dateString}`
        history.push(fullUrl, {flowEntries: entries, currentWeekStart: date});
    }

    return (
        <button className='big-pic-btn'
            onClick={onClick}
            style={{color: 'black'}}>
                Reflect & Discover ✨
        </button>
    )
}

export default WeekReflectionButton;